import { render } from "./DemoCrudCharForm.vue?vue&type=template&id=364a7f0c&scoped=true"
import script from "./DemoCrudCharForm.vue?vue&type=script&lang=js"
export * from "./DemoCrudCharForm.vue?vue&type=script&lang=js"

import "./DemoCrudCharForm.vue?vue&type=style&index=0&id=364a7f0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364a7f0c"]])

export default __exports__